// extracted by mini-css-extract-plugin
export default {"dialog":"DefaultModal_dialog__v2ufL","Modal":"DefaultModal_Modal__B6vHy"};